import * as React from "react";
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import Toolbar from "@mui/material/Toolbar";
import IconButton from "@mui/material/IconButton";
import Badge from "@mui/material/Badge";
import MenuIcon from "@mui/icons-material/Menu";
import SearchIcon from "@mui/icons-material/Search";
import AccountCircle from "@mui/icons-material/AccountCircle";
import Image from "next/image";
import SwipeableDrawer from "@mui/material/SwipeableDrawer";
import Container from "@mui/material/Container";
import Typography from "@mui/material/Typography";
import { useTheme } from "@mui/material";
import useMediaQuery from "@mui/material/useMediaQuery";
import ShoppingCartIcon from "@mui/icons-material/ShoppingCart";
import Categories from "./Categories";
import Link from "next/link";
import { useRouter } from "next/router";
import { apiUser } from "@Services/API/IndividualApi's/User";
import Cookies from "js-cookie";
import { useDispatch, useSelector } from "react-redux";
import { CartActions } from "@Redux-Store/Actions/CartActions";
import { useEffect, useRef } from "react";
import MobileSideDrawerContent from "./MobileSideDrawerContent";
import { CategoryHierarchy } from "@Interfaces/Api/category";
import { apiCategories } from "@Services/API/IndividualApi's/Category";
import { apiProduct } from "@Services/API/IndividualApi's/Products";
import { IProduct } from "@Interfaces/Api/Product";
import { useState } from "react";
import Search from "./Search";
import LoginIcon from "@mui/icons-material/Login";
import UserMenu from "./UserMenu";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";
import "swiper/css";

export default function PrimarySearchAppBar() {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [mobileMoreAnchorEl, setMobileMoreAnchorEl] = React.useState(null);
  const [showMobileSearch, setShowMobileSearch] = React.useState(false);
  const [isDrawerOpen, setIsDrawerOpen] = React.useState(false);
  const [totalCartItem, setTotalCartItem] = React.useState<number>(0);
  const [searchResult, setSearchResult] = React.useState<IProduct[]>([]);
  const [allProducts, setAllProducts] = React.useState<IProduct[]>([]);
  const [isSearchDropDownOpen, setIsSearchDropDownOpen] = useState<boolean>(
    false
  );
  const [categoryHierarchy, setCategoryHierarchy] = React.useState<
    CategoryHierarchy[]
  >([]);

  const [searchText, setSearchText] = React.useState<string>("");
  // const userId = Cookies.get("userId");
  const theme = useTheme();
  const dispatch = useDispatch();
  const cartData = useSelector((state) => state?.CartReducer?.cart);
  const isDesktop = useMediaQuery(theme.breakpoints.up("sm"));
  const menuId = "primary-search-account-menu";
  const router = useRouter();

  const [clientUserId, setClientUserId] = useState<string | undefined>(
    undefined
  );

  useEffect(() => {
    const uid = Cookies.get("userId");
    setClientUserId(uid);
  }, []);

  const allHeaderNotification = useSelector(
    (state) => state?.CartReducer?.headerNotification
  );

  const [headerNotification, setHeaderNotification] = useState<any>();
  useEffect(() => {
    if (allHeaderNotification) {
      setHeaderNotification(allHeaderNotification);
    }
  }, [allHeaderNotification]);

  useEffect(() => {
    let Quantity = 0;
    if (cartData) {
      cartData?.cartItems?.map((cartItem) => {
        Quantity += cartItem.quantity;
      });
      setTotalCartItem(Quantity);
    }
    if (cartData == null) {
      setTotalCartItem(Quantity);
    }
  }, [cartData]);

  const handleLogout = async () => {
    const obj = {};
    try {
      const response = await apiUser.logout(obj);
      window.location.reload();
      handleMenuClose();
      dispatch(CartActions.ClearCart());
      router.push("/");
    } catch (err) { }
  };

  const handleProfileMenuOpen = (event: any) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMobileMenuClose = () => {
    setMobileMoreAnchorEl(null);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
    handleMobileMenuClose();
  };

  React.useEffect(() => {
    getCategoryHierarchy();
  }, []);

  const getCategoryHierarchy = async () => {
    try {
      const response = await apiCategories.getHierarchy();
      setCategoryHierarchy(response);
    } catch (err) { }
  };
  const toggleDrawer = (open: boolean) => (event: any) => {
    if (
      event &&
      event.type === "keydown" &&
      (event.key === "Tab" || event.key === "Shift")
    ) {
      return;
    }
    setIsDrawerOpen(open);
  };

  const onHideInMobile = () => {
    setShowMobileSearch(false);
  };

  function handleSearchTextChanged(value: string): void {
    if (value) {
      setIsSearchDropDownOpen(true);
    }
    setSearchText(value);
  }

  useEffect(() => {
    handleSearch();
  }, [searchText]);

  const handleSearch = async () => {
    if (!searchText) {
      setIsSearchDropDownOpen(false);
    } else {
      try {
        const response = await apiProduct.search(searchText, 1, 10);
        setSearchResult(response.data);
      } catch (err) {
        console.log(err);
      }
    }
  };

  useEffect(() => {
    if (searchResult) {
      const searchValue: React.SetStateAction<IProduct[]> = [];
      searchResult.forEach((val) => searchValue.push(val));
      setAllProducts(searchValue);
    }
  }, [searchResult]);

  const resetDefault = () => {
    setShowMobileSearch(false);
    setIsSearchDropDownOpen(false);
    setSearchText("");
  };
  const [activeStep, setActiveStep] = React.useState(0);
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  const handleStepChange = (step: number) => {
    setActiveStep(step);
  };

  const ref = useRef<HTMLDivElement>(null);
  const height: any = ref?.current?.offsetHeight;

  return (
    <Box
      sx={{
        // flexGrow: 1,
        paddingBottom: { sm: "8rem" },
      }}
    >
      {router.pathname == "/" && (
        <Box
          ref={ref}
          style={{
            position: "fixed",
            top: "0",
            zIndex: "10001",
            width: "100%",
          }}
        >
          <Swiper
            modules={[Autoplay]}
            autoplay={{ delay: 4000, disableOnInteraction: false }}
            loop
            allowTouchMove={false}
          >
            {headerNotification?.map((val: string, index: number) => (
              <SwiperSlide key={index}>
                <Typography
                  sx={{
                    background: theme.palette.primary.dark,
                    color: "#fff",
                    textAlign: "center",
                    fontSize: { sm: "1rem", xs: "0.65rem" },
                  }}
                >
                  {val}
                </Typography>
              </SwiperSlide>
            ))}
          </Swiper>
        </Box>
      )}

      <AppBar
        sx={{
          position: { xs: "static", sm: "fixed" },
          marginBottom: `${height}px`,
        }}
        color="inherit"
      >
        <Box
          sx={{
            position: { xs: "fixed", sm: "static" },
            boxShadow: { xs: 3, sm: 0 },
            background: "inherit",
            width: "100%",
            zIndex: 100,
            paddingTop: `${height}px`,
          }}
        >
          <Container style={{ paddingLeft: "0px", paddingRight: "0px" }}>
            <Toolbar style={{ paddingRight: "4px" }}>
              <IconButton
                size="large"
                edge="start"
                color="inherit"
                aria-label="open drawer"
                sx={{ mr: 2, display: { xs: "flex", sm: "none" } }}
                onClick={() => setIsDrawerOpen((preState) => !preState)}
              >
                <MenuIcon style={{ color: theme.palette.primary.main }} />
              </IconButton>

              <Link href="/">
                <Image
                  alt="econut-logo"
                  src="/static/images/econut-logo1.png"
                  width={isMobile ? 90 : 150}
                  height={isMobile ? 25 : 40}
                  objectFit="contain"
                  priority={true}
                />
              </Link>
              <Box sx={{ flexGrow: 1 }} />
              {isDesktop ? (
                <Search
                  allProducts={allProducts}
                  resetToDefault={resetDefault}
                  isSearchDropDownOpen={isSearchDropDownOpen}
                  handleSearchTextChanged={handleSearchTextChanged}
                  searchText={searchText}
                  onHideInMobile={() => console.log()}
                  showMobileSearch={showMobileSearch}
                />
              ) : (
                <>
                  {!showMobileSearch ? (
                    <IconButton size="large" aria-label="cart" color="inherit">
                      <SearchIcon
                        onClick={() => setShowMobileSearch(true)}
                        style={{ color: theme.palette.primary.main }}
                      />
                    </IconButton>
                  ) : (
                    ""
                  )}
                </>
              )}

              <Box
                sx={{ display: { xs: "flex", md: "flex" } }}
                style={{ color: theme.palette.primary.main }}
              >
                {isDesktop && clientUserId && (
                  <IconButton
                    style={{ margin: "0 2px" }}
                    size="large"
                    edge="end"
                    aria-label="account of current user"
                    aria-controls={menuId}
                    aria-haspopup="true"
                    onClick={handleProfileMenuOpen}
                    color="inherit"
                  >
                    {clientUserId && <AccountCircle />}
                  </IconButton>
                )}
                <Link href={`/myCart`}>
                  <IconButton size="large" aria-label="cart" color="inherit">
                    <Badge badgeContent={totalCartItem} color="error">
                      <ShoppingCartIcon style={{ color: "#00844a" }} />
                    </Badge>
                  </IconButton>
                </Link>

                {clientUserId == undefined ? (
                  <IconButton size="large" aria-label="cart" color="inherit">
                    <Link href={"/login"}>
                      <LoginIcon style={{ color: "#00844a" }} />
                    </Link>
                  </IconButton>
                ) : (
                  ""
                )}
              </Box>
            </Toolbar>
          </Container>
          {showMobileSearch && (
            <Search
              allProducts={allProducts}
              resetToDefault={resetDefault}
              isSearchDropDownOpen={isSearchDropDownOpen}
              handleSearchTextChanged={handleSearchTextChanged}
              searchText={searchText}
              onHideInMobile={onHideInMobile}
              showMobileSearch={showMobileSearch}
            />
          )}
        </Box>
        <Container style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center"
        }}>
          <Categories categoryHierarchy={categoryHierarchy} />
          <Link href={`/blogs`}>
            <Typography
              variant="caption"
              sx={{
                fontSize: { xs: "0.75rem", sm: "1rem" },
                marginBottom: "0.7rem",
                textAlign: "center",
                textTransform: { xs: "capitalize", sm: "uppercase" },
                display: { xs: "none", sm: "flex" },
              }}
            >
              Blogs
            </Typography>
          </Link>
        </Container>
      </AppBar>
      <UserMenu
        handleLogout={handleLogout}
        handleMenuClose={handleMenuClose}
        anchorEl={anchorEl}
      />
      <SwipeableDrawer
        open={isDrawerOpen}
        onClose={toggleDrawer(false)}
        onOpen={toggleDrawer(true)}
      >
        <MobileSideDrawerContent
          toggleDrawer={toggleDrawer}
          categoryHierarchy={categoryHierarchy}
        />
      </SwipeableDrawer>
    </Box>
  );
}
